import { MMMProduct } from './types';
import { Device, webViewCallbacks } from '@nykaa/webview-wizard/constant';
import { webViewCallbackhandler } from '@nykaa/webview-wizard';
import {
  isDeviceAndroid,
  isDeviceNotWeb,
} from '@nykaa/data-layer/utils/device';
import {
  FOUNDATION_FINDER_SITE_NAV,
  FOUNDATION_FINDER_SHADE_MATCH,
  QUIZ_MATCHER,
  TAKE_QUIZ_FLOW_COMPLETE,
  MATCH_CURRENT_SHADE_FLOW_COMPLETE,
  FOUNDATION_FINDER_POPUP,
  BRAND_TO_BRAND_JOURNEY,
  TAKE_QUIZ_FLOW_INITIATED,
  MATCH_CURRENT_SHADE_FLOW_INITIATED,
  FOUNDATION_FINDER_QUIZ,
} from './constants';

export const doAddToCartViaApp = (
  product: MMMProduct,
  device: Device,
  journeyType: string
) => {
  if (isDeviceNotWeb(device)) {
    const { sku = [], productName } = product || {};
    const cartAddLoc =
      journeyType === BRAND_TO_BRAND_JOURNEY
        ? FOUNDATION_FINDER_SHADE_MATCH
        : FOUNDATION_FINDER_QUIZ;
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.addProduct,
      callbackParams: {
        id: sku[0],
        name: productName,
        param: {
          add_to_cart_location: cartAddLoc,
          interaction_location: cartAddLoc,
          site_navigation: FOUNDATION_FINDER_SITE_NAV,
          site_sub_navigation: cartAddLoc,
        },
      },
    };
    webViewCallbackhandler(appParams);
    return;
  }
};

export const closeMMMWidget = (device: Device) => {
  if (isDeviceNotWeb(device)) {
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.hideWebview,
      callbackParams: isDeviceAndroid(device) ? null : {},
      passValidParamsOnly: true,
    };
    webViewCallbackhandler(appParams);
    return;
  }
};

export const fireFlowCompletionEvent = (
  device: Device,
  journeyType: string
) => {
  if (isDeviceNotWeb(device)) {
    const eventName =
      journeyType === QUIZ_MATCHER
        ? TAKE_QUIZ_FLOW_COMPLETE
        : MATCH_CURRENT_SHADE_FLOW_COMPLETE;
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.doMixpanel,
      callbackParams: {
        eventName: eventName,
        params: {},
      },
    };
    webViewCallbackhandler(appParams);
    return;
  }
};

export const fireScriptLoadCompletionEvent = (device: Device) => {
  if (isDeviceNotWeb(device)) {
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.onMMMInitSuccess,
      callbackParams: isDeviceAndroid(device) ? null : {},
      passValidParamsOnly: true,
    };
    webViewCallbackhandler(appParams);
    return;
  }
};

export const fireScriptFailEvent = (device: Device) => {
  if (isDeviceNotWeb(device)) {
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.onMMMInitFailure,
      callbackParams: isDeviceAndroid(device) ? null : {},
      passValidParamsOnly: true,
    };
    webViewCallbackhandler(appParams);
    return;
  }
};

export const fireFlowInitiatedEvent = (device: Device, journeyType: string) => {
  if (isDeviceNotWeb(device)) {
    const trackingData = {
      interaction_location: FOUNDATION_FINDER_POPUP,
    };
    const eventName =
      journeyType === BRAND_TO_BRAND_JOURNEY
        ? MATCH_CURRENT_SHADE_FLOW_INITIATED
        : TAKE_QUIZ_FLOW_INITIATED;
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.doMixpanel,
      callbackParams: {
        eventName: eventName,
        params: JSON.stringify(trackingData),
      },
    };
    webViewCallbackhandler(appParams);
    return;
  }
};
